<template>
  <div class="view box grow" v-loading="threatHuntingQuerySearchReqStatus === 'loading'">
    <page-headers
        :header="'Threat Hunting'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-threat-hunting"
        class="box"
    >
      <div slot="actions" class="float-right">
        <el-dropdown @command="selectSavedSearch">
          <el-button type="primary">Saved Searches<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown" class="saved-search_dropdown">
            <el-row class="custom-value-search">
              <el-input v-model="savedSearchInput" placeholder="Search">
                <i slot="prefix" class="material-icons">search</i>
              </el-input>
            </el-row>
            <el-dropdown-item v-for="savedSearch in userSavedQueries" :key="savedSearch.name" :command="savedSearch">{{
                savedSearch.name
              }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </page-headers>
    <div class="flex box grow">
      <query-builder
          @submit-query="getQueryResult"
          @reset-query-results="resetQueryResult"
          ref="queryBuilder"
      ></query-builder>
    </div>

    <table-toolbar
        v-if="threatHuntingQuerySearchReqStatus === 'saved'"
        :searchbar-visible="false"
        :refresh-visible="false"
        :column-edit-visible="false"
        :key="recordCountKey"
        :search-properties="threatHuntingQuerySearchResult.columns"
        :total-search-properties="threatHuntingQuerySearchResult.columns"
        :search-data="threatHuntingQuerySearchResult.data"
    >
      <div slot="toolbar-tools">
        <el-button
            type="text"
            class="cursor-pointer"
            @click="threatHuntingQuerySearchResult.data.downloadCsv(threatHuntingQuerySearchResult.columns)"
        >
          <i class="material-icons c-icon">vertical_align_bottom</i>
        </el-button>
      </div>
    </table-toolbar>

    <expanded-table-element
        v-if="threatHuntingQuerySearchReqStatus === 'saved'"
        :columns="threatHuntingQuerySearchResult.columns"
        :table-data="threatHuntingQuerySearchResult.data"
        :height-offset="250"
        ref="querySearchTable"
        @update-record-count="recordCountHandler"
    ></expanded-table-element>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import QueryBuilder from '@/components/query/QueryBuilder.vue'
import ExpandedTableElement from '@/components/table/ExpandedTableElement.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'

import {querySearchMetaInfo} from '@/column-header/query_search/query-search-meta'

import {THREAT_HUNTING_REQ, THREAT_HUNTING_SUCCESS} from '@/store/modules/threat_hunting/query-fields.type'
import {ALL_SAVED_SEARCH_REQ, ALL_SAVED_SEARCH_SUCCESS} from '@/store/modules/threat_hunting/saved-search.type'

export default {
  name: 'ThreatHunting',
  data() {
    return {
      breadcrumbs: [{title: 'Analytics'}, {title: 'Threat Hunting'}],
      queryColumns: querySearchMetaInfo.meta.columns,
      savedSearchInput: '',
      recordCountKey: true
    }
  },
  methods: {
    recordCountHandler() {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.recordCountKey = !this.recordCountKey
      this.threatHuntingQuerySearchResult.reloadToolbar = false
    },
    getQueryResult(filters) {
      this.$store
          .dispatch(THREAT_HUNTING_REQ, {
            dateRange: filters.dateRange,
            eventType: filters.eventType,
            queryCriteria: filters.filters
          })
          .then(results => {
            this.$store.dispatch(THREAT_HUNTING_SUCCESS)
          })
    },
    resetQueryResult(filters) {
      if (this.threatHuntingQuerySearchResult.data.models) {
        this.threatHuntingQuerySearchResult.data.models.length = 0
        if (this.$refs.querySearchTable) {
          this.threatHuntingQuerySearchResult.data.currentPage = 1
          this.$refs.querySearchTable.updateTableData()
          this.recordCountHandler()
        }
      }
    },
    selectSavedSearch(searchQuery) {
      this.$router.replace({
        query: {
          search: searchQuery.search_query
        }
      })
      // this.$refs["queryBuilder"].setQueryCriteriaFieldFromParam(searchQuery.search_query);
    }
  },
  created() {
    this.$store.dispatch(ALL_SAVED_SEARCH_REQ).then(() => {
      this.$store.dispatch(ALL_SAVED_SEARCH_SUCCESS)
    })
  },
  computed: {
    userSavedQueries() {
      if (_.isEmpty(this.savedSearchInput)) {
        return this.allSavedSearches.models
      }
      return _.filter(this.allSavedSearches.models, saved => {
        return saved.name.toLowerCase().includes(this.savedSearchInput.toLowerCase())
      })
    },
    ...mapGetters([
      'threatHuntingEventTypesReqStatus',
      'threatHuntingQuerySearchReqStatus',
      'threatHuntingQuerySearchResult',
      'allSavedSearches'
    ])
  },
  components: {
    PageHeaders,
    QueryBuilder,
    ExpandedTableElement,
    TableToolbar
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

.el-button {
  height: 32px;
  padding: 4px 12px;
  border-radius: 2px;
}

.saved-search_dropdown {
  width: 250px;
  padding: 10px;

  >>> .el-input__prefix {
    margin-top: 8px;
  }

  .el-dropdown-menu__item:first-of-type {
    margin-top: 6px;
  }
}

>>> .el-table__header-wrapper {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/threat-hunting/ThreatHunting.vue